import { createFileRoute } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { identityKeys } from '@/lib/queries/identity';
import { ConnectedAccountsClient } from './-components/ConnectedAccountsClient';

export const Route = createFileRoute('/_authed/settings/connected/')({
  component: SettingsConnectedPage,
});

function SettingsConnectedPage() {
  const query = useQuery({
    ...identityKeys.connectedAccounts(),
    retry: false,
  });
  const loadError = query.isError
    ? query.error instanceof Error
      ? query.error.message
      : 'load_failed'
    : null;
  return <ConnectedAccountsClient loadError={loadError} />;
}
